// Libs
import axios from 'axios';
import _ from 'lodash'

// Actions
import { changeLocalLoading, changeErr, changeSuccess } from '../App/actions'
import { signOut } from '../Deauth/actions'
import { reset } from 'redux-form'

// Axios
import { serverAPI } from '../../index'

export function createInicial(data) {
  return function (dispatch) {

    const { file1, file2 } = data
    let formData = new FormData();

    Object.keys(data).forEach(item => {
      formData.append(item, data[item])
    })

    formData.append('file1', file1[0])
    formData.append('companyCategory', 'Outros')

    if (file2) {
      Object.keys(file2).forEach((item, index) => {
        formData.append(`file${index + 2}`, file2[index])
      })
    }

    dispatch(changeLocalLoading(true))
    return serverAPI.post('/case/lawyer', formData)
      .then(response => {
        dispatch(changeLocalLoading(false))
        dispatch(changeSuccess('A inicial foi inserida na plataforma com sucesso. Acompanhe este caso na aba "Em Análise"'))
        dispatch(reset('newInicial'))
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
            dispatch(changeErr('Ocorreu um erro no envio do formulário. Entre em contato com um de nossos operadores via chat'))
        }
      })
  }
}
